import { Stack, Typography, useTheme } from "@mui/material";
import { type Control, useController } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { portfolioGroupLabel } from "web_myplann/Portfolio/Helpers/portfolioCategoryMapping";
import { togglePortfolioCategory } from "web_myplann/Portfolio/Helpers/togglePortfolioCategory";
import { useEffectivePortfolioFilter } from "web_myplann/Portfolio/Hooks/useEffectivePortfolioFilter";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";
import { FlatRowSwitch } from "web_myplann/Shared/Components/FlatRow/FlatRowSwitch";

type Props = {
	control: Control<FilterFormValues>;
};

export const CategoryFilterSection = ({ control }: Props) => {
	const { t } = useResource();
	const theme = useTheme();
	const { availableCategories } = useEffectivePortfolioFilter();
	const { field } = useController({ control, name: "categories" });
	const { value, onChange } = field;

	const isShown = (id: PortfolioCategoryId) =>
		value.length === 0 || value.includes(id);
	const shownCount = availableCategories.filter(isShown).length;

	const toggleCategory = (id: PortfolioCategoryId) =>
		onChange(togglePortfolioCategory(value, id, availableCategories));

	return (
		<>
			<Typography
				variant="overline"
				display="block"
				pt={2.4}
				px={theme.spacingTokens.lg}
				pb={theme.spacingTokens.sm}
			>
				{t(Resources.Portfolio.List.Redesign.Filter.categoriesLabel)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				{availableCategories.map((id, index) => (
					<FlatRowSwitch
						key={id}
						redesigned
						label={t(portfolioGroupLabel(id))}
						checked={isShown(id)}
						disabled={shownCount === 1 && isShown(id)}
						onChange={() => toggleCategory(id)}
						isLast={index === availableCategories.length - 1}
					/>
				))}
			</Stack>
		</>
	);
};
